export default __webpack_public_path__ + "static/media/qualipo-certificate.47a35a63.png";